import { Button } from 'antd';
import { useData } from '../../../shared/hooks/use-data';
import { StyledContainer } from '../../../shared/styled-components/styled-container.style';
import { TData } from '../../../shared/types/data';
import {
    StyledButton,
    StyledButtonContainer,
    StyledCard,
    StyledContent,
    StyledImage,
    StyledLeftContainer,
    StyledParagraph,
    StyledRightContainer,
    StyledTextContent,
    StyledTitle,
} from './list-item.style';
import { baseImagesUrl } from '../../../app';

export const ListItem = ({ item }: { item: TData }) => {
    const { selectedDataItem, setSelectedDataItem, setDetailsModalInfo } = useData();
    return (

        <StyledContainer
            $width="100%"
            key={item.id}
        >
            <StyledCard
                $isActive={selectedDataItem?.id === item.id}
                onClick={() => setSelectedDataItem(item)}>
                <StyledContent>
                    <StyledLeftContainer $width='30%'>
                        <StyledImage
                            key={item.id}
                            src={`${baseImagesUrl}/${item.images[0]}`}
                            alt="image"
                            preview={false}
                        />
                    </StyledLeftContainer>
                    <StyledRightContainer>
                        <StyledTextContent>
                            <StyledTitle>{item.name}</StyledTitle>
                            <StyledParagraph>{item.address}</StyledParagraph>
                        </StyledTextContent>
                        <StyledButtonContainer onClick={(e) => e.stopPropagation()}>
                            <StyledButton onClick={() => setDetailsModalInfo(item)}>Подробнее</StyledButton>
                        </StyledButtonContainer>
                    </StyledRightContainer>
                </StyledContent>
            </StyledCard>
        </StyledContainer>
    )
}